// Generated by Claude Code
import { AutomationsPage } from '#components/domain/operations/automations/automations-page.tsx'
import { PermissionGuard } from '#components/tools/permission-guard.tsx'
import { PermissionAction, PermissionService } from '#core/entities/auth/roles/Permission.ts'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/$companyId/automations/')({
  component: RouteComponent,
  staticData: {
    title: 'Automations',
  },
})

function RouteComponent() {
  return (
    <PermissionGuard
      permissions={[[[PermissionService.AUTOMATIONS, PermissionAction.READ]]]}
      redirectOnNotAuthorized
    >
      <AutomationsPage />
    </PermissionGuard>
  )
}
